import Intro from './challenges/Intro';
import Profile from './challenges/Profile';
import Accordion from './challenges/Accordion';
import Article from './challenges/Article';
import Social from './challenges/Social';
import Bootcamp from './challenges/Bootcamp';

function App() {
  return (
    <div className="App">
      <Intro />
      <Profile />
      <Accordion />
      <Social />
      <Article />
      <Bootcamp />
      {/* four card feature */}
      {/* base apparel */}
      {/* intro sign up */}
      {/* single price grid */}
      {/* ping coming soon */}
      {/* huddle */}
      {/* three column preview */}
    </div>
  );
}

export default App;
